import PageHeader from "./PageHeader";
import "./StaticPages.css";


const Error404Page = () => {
  return (
    <div id="static-page">
      <PageHeader mainHeader="Error 404." subHeader="We couldn't find that page." />
    </div>  
  )
}

export default Error404Page;